import { render, staticRenderFns } from "./NavBarButton.vue?vue&type=template&id=d31ec5f2&scoped=true&"
import script from "./NavBarButton.vue?vue&type=script&lang=js&"
export * from "./NavBarButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBarButton.vue?vue&type=style&index=0&id=d31ec5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31ec5f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarButtonLink: require('/builds/mytia/mege-educacional/components/NavBarButtonLink.vue').default})
